import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import LocationalState from "../LocationalState";

interface TagProps {
}

interface DispatchProps {
}

interface StateProps {
    inProgress: boolean,
    progress: string,
}


type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        inProgress: selectors.loadingInProgress(state),
        progress: selectors.progress(state),
    };
};

const mapDispatchToProps: DispatchProps = ({

});

class Component extends React.Component<Props, {}> {

    render(){
        const {inProgress, progress} = this.props;
        if (!inProgress) {
            return null;
        }

        let progressWidth = progress + "%";

        return (
            <div className={"progress-overlay"}>

                <div className={"progressorModal"}>
                    <div className={"cssloader"} />
                    <div className={"progressContainer"}>
                        <div className={"progressIndicator"} style={{width: progressWidth}} />
                    </div>
                </div>
            </div>
        );
    }

}

export const ProgressOverlay = connect(mapStateToProps, mapDispatchToProps)(Component);